// Przełącznik PL | EN (wersja angielska — src/i18n). Zmiana = przeładowanie strony;
// zalogowanemu język zapisuje się też na koncie (maile).
import { LANG, setLang, type Lang } from '../i18n/lang'

export function LangSwitch({ className = '' }: { className?: string }) {
  const opt = (l: Lang) => (
    <button
      key={l}
      type="button"
      onClick={() => { if (l !== LANG) setLang(l) }}
      aria-pressed={l === LANG}
      className={[
        'px-2 py-1 text-[11px] font-bold tracking-wide transition-colors',
        l === LANG ? 'bg-white/[0.16] text-white' : 'text-white/55 hover:text-white',
      ].join(' ')}
    >
      {l.toUpperCase()}
    </button>
  )
  return (
    <div translate="no" className={`inline-flex overflow-hidden rounded-md border border-white/20 ${className}`} title="Język / Language">
      {opt('pl')}
      {opt('en')}
    </div>
  )
}
